import { FC, useContext } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const Story: FC<any> = ({ data }) => {
	const { lang } = useContext(GlobalContext);

	const imageTitle = translate(lang, {
		en: `Viber Success Stories ${data?.url}`,
		ru: `Истории успеха Viber ${data?.url}`,
		ua: `Історії успіху Viber ${data?.url}`,
	});

	return (
		<LocalizedLink href={`/success-stories/story/${data?.url}/`}>
			<div>
				<ImageWrapper>
					<Image
						loading="lazy"
						alt={imageTitle}
						src={getImage(data?.preview)}
					/>
				</ImageWrapper>

				<Content>
					<Title>{parseHTML(data?.story?.title)}</Title>

					<Paragraph>{parseHTML(data?.story?.shortDescription)}</Paragraph>
				</Content>
			</div>
		</LocalizedLink>
	);
};

const ImageWrapper = styled.div`
	width: 100%;
	padding-top: 48%;
	position: relative;
	overflow: hidden;
	border-radius: 40px;
	margin-bottom: 25px;
	mask-image: radial-gradient(#fff, #000);

	&:hover {
		img {
			transform: scale(1.08);
		}
	}

	@media (max-width: 600px) {
		border-radius: 20px;
	}

	@media (max-width: 400px) {
		border-radius: 15px;
	}

	@media (min-width: 1600px) {
		border-radius: 46px;
	}
`;

const Image = styled.img`
	position: absolute;
	width: 100%;
	max-width: 100%;
	top: 0;
	left: 0;
	display: block;
	border-radius: 30px;
	transition: 0.3s;

	@media (max-width: 600px) {
		margin-bottom: 12px;
		border-radius: 20px;
	}

	@media (max-width: 400px) {
		margin-bottom: 12px;
		border-radius: 15px;
	}
`;

const Content = styled.div`
	box-sizing: border-box;
	padding-left: 15px;
	padding-right: 15px;
`;

const Title = styled.h3`
	font-family: var(--font-sans);

	font-size: 27px;
	line-height: 35px;
	color: var(--color-purple);

	@media (max-width: 1000px) {
		font-size: 20px;
	}

	@media (max-width: 600px) {
		font-size: 18px;
		line-height: 27px;
	}

	@media (max-width: 535px) {
		font-size: 22px;
		line-height: 25px;
	}
`;

const Paragraph = styled.div`
	width: 340px;
	max-width: 100%;
	margin-top: 15px;
	font-family: var(--font-sans);

	font-size: 18px;

	line-height: 25px;
	color: var(--color-purple-50);

	@media (max-width: 1000px) {
		font-size: 16px;
		margin-top: 4px;
		line-height: 24px;
	}

	@media (max-width: 600px) {
		font-size: 14px;
		margin-top: 5px;
		line-height: 24px;
	}

	@media (max-width: 535px) {
		font-size: 16px;
		line-height: 25px;
	}
`;

export default Story;
